export default __webpack_public_path__ + "static/AXR_solution-9cac7f514c04721756de7effc31a326c.jpg";